module.exports = __webpack_public_path__ + "img/partner-3.84254690.png";